import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { authService } from '../services/api'
import CheckoutModal from '../components/CheckoutModal'
import './CompletarPerfil.css'

function AdicionarTipo() {
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [loading, setLoading] = useState(false)
    const [erro, setErro] = useState('')
    const [checkoutAtivo, setCheckoutAtivo] = useState(false)
    const [loadingPlaca, setLoadingPlaca] = useState(false)

    const novoTipo = searchParams.get('tipo') || 'vendedor'

    const [formData, setFormData] = useState({
        // Dados pessoais básicos
        cpfCnpj: usuario?.cpfCnpj || usuario?.cpf_cnpj || '',
        telefone: usuario?.telefone || '',
        cidade: usuario?.cidade || '',
        estado: usuario?.estado || '',
        // Campos de vendedor
        nomeFazenda: '',
        cidadeFazenda: '',
        estadoFazenda: '',
        // Campos de motorista
        tipoVeiculo: usuario?.tipo_veiculo || usuario?.tipoVeiculo || '',
        placaVeiculo: usuario?.placa_veiculo || usuario?.placaVeiculo || '',
        capacidadePeso: usuario?.capacidade_peso || usuario?.capacidadePeso || '',
        capacidadeGado: usuario?.capacidade_gado || usuario?.capacidadeGado || '',
        fotoVeiculo: usuario?.foto_veiculo || usuario?.fotoVeiculo || '',
        modeloVeiculo: usuario?.modelo_veiculo || usuario?.modeloVeiculo || ''
    })

    const hasDadosPessoais = !!(usuario?.cpfCnpj || usuario?.cpf_cnpj) && !!usuario?.telefone && !!usuario?.cidade && !!usuario?.estado;

    useEffect(() => {
        if (!isLogado) {
            navigate('/login')
        }
    }, [isLogado, navigate])

    const handleLookupPlaca = async () => {
        const placa = formData.placaVeiculo.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if (placa.length < 7) return;

        setLoadingPlaca(true);
        setErro('');
        try {
            const token = localStorage.getItem('token');
            const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/util/consulta-placa/${placa}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await resp.json();
            
            if (data.sucesso && data.veiculo) {
                setFormData(prev => ({
                    ...prev,
                    tipoVeiculo: data.veiculo.tipo || prev.tipoVeiculo,
                    // Campos extras capturados da API
                    modeloVeiculo: data.veiculo.nomeCompleto,
                    marcaVeiculo: data.veiculo.marca
                }));
                // Feedback visual de sucesso
                console.log('Veículo identificado:', data.veiculo.nomeCompleto);
            } else if (data.error) {
                setErro(data.message || 'Placa não encontrada no banco de dados nacional.');
            }
        } catch (e) {
            console.error('Falha ao consultar placa:', e);
        } finally {
            setLoadingPlaca(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        setErro('')
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErro('')

        try {
            // Sempre chamamos o serviço para salvar os dados (especialmente útil para motoristas que já pagaram mas ainda não preencheram o veículo)
            await authService.adicionarTipo({
                novoTipo,
                ...formData
            })

            // Interceptar fluxo para Motoristas (Painel Pago)
            const modo = searchParams.get('modo');
            const isVerificado = usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true;

            if (novoTipo === 'motorista' && modo !== 'editar' && !isVerificado) {
                try {
                    const token = localStorage.getItem('token');
                    const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/pagamentos/checkout-motorista`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    const data = await resp.json();
                    if (data.url) {
                        window.location.href = data.url; // Redireciona na mesma aba!
                        return;
                    } else {
                        throw new Error(data.message || 'Não foi possível gerar o link de pagamento');
                    }
                } catch (e) {
                    console.error("Erro no redirecionamento do checkout:", e);
                    setErro('Não foi possível gerar o pagamento do plano. Tente novamente.');
                    setLoading(false);
                    return;
                }
            }

            navigate('/')
            window.location.reload()
        } catch (error) {
            setErro(error.message || 'Erro ao adicionar tipo')
        } finally {
            setLoading(false)
        }
    }

    const getTipoInfo = () => {
        switch (novoTipo) {
            case 'comprador':
                return {
                    icon: '🛒',
                    titulo: 'Adicionar Perfil de Comprador',
                    desc: 'Complete os dados para poder fazer compras'
                }
            case 'vendedor':
                return {
                    icon: '🏷️',
                    titulo: 'Adicionar Perfil de Vendedor',
                    desc: 'Complete os dados da sua fazenda para poder vender'
                }
            case 'motorista':
                return {
                    icon: '🚚',
                    titulo: 'Adicionar Perfil de Motorista',
                    desc: 'Complete os dados do seu veículo para fazer fretes'
                }
            default:
                return { icon: '👤', titulo: 'Adicionar Perfil', desc: '' }
        }
    }

    const tipoInfo = getTipoInfo()

    const estados = [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
        'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
        'SP', 'SE', 'TO'
    ]

    const tiposVeiculo = [
        'Caminhão Boiadeiro',
        'Carreta Boiadeira',
        'Caminhão Truck',
        'Bi-trem',
        'Rodotrem',
        'Veículo Comum'
    ]

    return (
        <div className="completar-page">
            {/* Modal de confirmação de pagamento PIX */}
            {checkoutAtivo && (
                <CheckoutModal
                    plano="motorista"
                    onClose={() => setCheckoutAtivo(false)}
                    onConfirmado={() => {
                        window.location.href = '/fretes-disponiveis';
                    }}
                />
            )}

            <div className="completar-container">
                <div className="completar-card">
                    <div className="completar-header">
                        <div className="completar-icon">{tipoInfo.icon}</div>
                        <h1>{tipoInfo.titulo}</h1>
                        <p>{tipoInfo.desc}</p>
                    </div>

                    <div className="verificado-badge">
                        <span className="badge-icon">✨</span>
                        <span>Você poderá alternar entre seus perfis a qualquer momento!</span>
                    </div>

                    {erro && (
                        <div className="alert alert-error">
                            {erro}
                        </div>
                    )}

                    {novoTipo === 'motorista' && (
                        <div className="alert alert-warning" style={{ 
                            backgroundColor: 'rgba(245, 158, 11, 0.1)', 
                            borderLeft: '4px solid #f59e0b',
                            padding: '1.5rem',
                            marginBottom: '1.5rem',
                            borderRadius: '8px',
                            color: '#eab308'
                        }}>
                            <h3 style={{ margin: '0 0 0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                📢 Aviso Importante
                            </h3>
                            <p style={{ margin: 0, lineHeight: '1.5', fontSize: '1rem' }}>
                                Após o pagamento, seu nome será adicionado à lista de motoristas disponíveis na plataforma 
                                e você será liberado para se candidatar em qualquer anúncio.
                            </p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="completar-form">
                        {/* Dados pessoais - mostrados apenas se o usuário ainda não os cadastrou */}
                        {!hasDadosPessoais && (
                            <div className="form-section">
                                <h3>📋 Dados Pessoais</h3>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">CPF ou CNPJ *</label>
                                        <input
                                            type="text"
                                            name="cpfCnpj"
                                            className="form-input"
                                            placeholder="000.000.000-00"
                                            value={formData.cpfCnpj}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Telefone *</label>
                                        <input
                                            type="tel"
                                            name="telefone"
                                            className="form-input"
                                            placeholder="(00) 00000-0000"
                                            value={formData.telefone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Cidade *</label>
                                        <input
                                            type="text"
                                            name="cidade"
                                            className="form-input"
                                            placeholder="Sua cidade"
                                            value={formData.cidade}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Estado *</label>
                                        <select
                                            name="estado"
                                            className="form-input"
                                            value={formData.estado}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Selecione</option>
                                            {estados.map(uf => (
                                                <option key={uf} value={uf}>{uf}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Campos específicos - Vendedor */}
                        {novoTipo === 'vendedor' && (
                            <div className="form-section">
                                <h3>🏠 Dados da Fazenda</h3>

                                <div className="form-group">
                                    <label className="form-label">Nome da Fazenda *</label>
                                    <input
                                        type="text"
                                        name="nomeFazenda"
                                        className="form-input"
                                        placeholder="Ex: Fazenda Bom Sucesso"
                                        value={formData.nomeFazenda}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Cidade da Fazenda</label>
                                        <input
                                            type="text"
                                            name="cidadeFazenda"
                                            className="form-input"
                                            placeholder="Cidade onde fica a fazenda"
                                            value={formData.cidadeFazenda}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Estado</label>
                                        <select
                                            name="estadoFazenda"
                                            className="form-input"
                                            value={formData.estadoFazenda}
                                            onChange={handleChange}
                                        >
                                            <option value="">Selecione</option>
                                            {estados.map(uf => (
                                                <option key={uf} value={uf}>{uf}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Campos específicos - Motorista */}
                        {novoTipo === 'motorista' && (
                            <div className="form-section">
                                <h3>🚚 Dados do Veículo</h3>

                                <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                                    <label className="form-label">Foto do Veículo</label>
                                    <div className="upload-container" style={{ 
                                        border: '2px dashed rgba(255,255,255,0.1)', 
                                        borderRadius: '12px', 
                                        padding: '2rem', 
                                        textAlign: 'center',
                                        backgroundColor: 'rgba(255,255,255,0.02)'
                                    }}>
                                        {formData.fotoVeiculo ? (
                                            <div className="preview-veiculo" style={{ position: 'relative', display: 'inline-block' }}>
                                                <img 
                                                    src={formData.fotoVeiculo?.startsWith('http') ? formData.fotoVeiculo : `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}${formData.fotoVeiculo}`} 
                                                    alt="Veículo" 
                                                    style={{ width: '100%', maxHeight: '200px', borderRadius: '8px', objectFit: 'cover' }} 
                                                />
                                                <button 
                                                    type="button"
                                                    onClick={() => setFormData({...formData, fotoVeiculo: ''})}
                                                    style={{ position: 'absolute', top: '-10px', right: '-10px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', width: '25px', height: '25px', cursor: 'pointer' }}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ) : (
                                            <label className="upload-label" style={{ cursor: 'pointer' }}>
                                                <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📸</div>
                                                <p>Clique para subir a foto do seu veículo</p>
                                                <input 
                                                    type="file" 
                                                    accept="image/*" 
                                                    style={{ display: 'none' }} 
                                                    onChange={async (e) => {
                                                        const file = e.target.files[0];
                                                        if (!file) return;
                                                        
                                                        const formDataUpload = new FormData();
                                                        formDataUpload.append('image', file);
                                                        
                                                        try {
                                                            setLoading(true);
                                                            const token = localStorage.getItem('token');
                                                            const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/upload`, {
                                                                method: 'POST',
                                                                headers: { 'Authorization': `Bearer ${token}` },
                                                                body: formDataUpload
                                                            });
                                                            const data = await resp.json();
                                                            if (data.filename || data.url) {
                                                                setFormData({ ...formData, fotoVeiculo: data.url || `/uploads/${data.filename}` });
                                                            }
                                                        } catch (err) {
                                                            console.error('Erro no upload da foto do veículo:', err);
                                                        } finally {
                                                            setLoading(false);
                                                        }
                                                    }}
                                                />
                                            </label>
                                        )}
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Tipo de Veículo *</label>
                                        <select
                                            name="tipoVeiculo"
                                            className="form-input"
                                            value={formData.tipoVeiculo}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Selecione</option>
                                            {tiposVeiculo.map(tipo => (
                                                <option key={tipo} value={tipo}>{tipo}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Placa do Veículo *</label>
                                        <input
                                            type="text"
                                            name="placaVeiculo"
                                            className={`form-input ${loadingPlaca ? 'loading-field' : ''}`}
                                            placeholder="ABC-1234"
                                            value={formData.placaVeiculo}
                                            onChange={handleChange}
                                            onBlur={handleLookupPlaca}
                                            required
                                        />
                                        {loadingPlaca && <small style={{color: 'var(--color-primary)'}}>🔍 Consultando veículo...</small>}
                                        {formData.modeloVeiculo && (
                                            <div style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#22c55e' }}>
                                                ✅ Veículo Identificado: <strong>{formData.modeloVeiculo}</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Capacidade de Peso (kg)</label>
                                        <input
                                            type="number"
                                            name="capacidadePeso"
                                            className="form-input"
                                            placeholder="Ex: 15000"
                                            value={formData.capacidadePeso}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">Qtd. de Gado que Transporta</label>
                                        <input
                                            type="number"
                                            name="capacidadeGado"
                                            className="form-input"
                                            placeholder="Ex: 30"
                                            value={formData.capacidadeGado}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-actions" style={{ flexDirection: 'column', gap: '1rem' }}>
                            <button
                                type="submit"
                                className={`btn btn-primary btn-lg btn-block ${loading ? 'loading' : ''}`}
                                disabled={loading}
                            >
                                {loading 
                                    ? 'Adicionando...' 
                                    : novoTipo === 'motorista' 
                                        ? (searchParams.get('modo') === 'editar' ? '✓ Salvar Alterações' : '✓ Salvar e Gerar Pagamento (R$ 49,90)')
                                        : `✓ Adicionar Perfil de ${novoTipo.charAt(0).toUpperCase() + novoTipo.slice(1)}`
                                }
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary btn-block"
                                onClick={() => navigate(-1)}
                            >
                                Cancelar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AdicionarTipo
